const DEFAULT_AVATAR = "/images/people-placeholder-img.png";
const CONTACT_SENSOR = "images/contact-sensor.jpg";
const MOTION_SENSOR = "images/motion-sensor.jpg";
const PUSH_BUTTON = "images/panic-button-sensor.png";
const RELAY = "images/relay-sensor.png";
const ALARM = "images/alarm-sensor.png";
const LIGHT_SWITCH = "images/light-switch-sensor.png";
const DOM_CAMERA = "/images/dom-camera.png";
const ALOCITY_READER = "/images/Alocity_reader_perspective front02_HD.png";
const DEFAULT_IMAGE_CAMERA = "/images/anavio-dome-sm.png";
const BULLET_IMAGE_CAMERA = "/images/anavio_bullet.png";
const CORNER_IMAGE_CAMERA = "/images/anavio_corner.png";
const MICRO_DOME_IMAGE_CAMERA = "/images/anavio_dome.png";
const FISHEYE_IMAGE_CAMERA = "/images/anavio_fisheye.png";
const DOME_IMAGE_CAMERA = "/images/anavio-dome-sm.png";

const Images = {
  DEFAULT_AVATAR,
  CONTACT_SENSOR,
  MOTION_SENSOR,
  PUSH_BUTTON,
  RELAY,
  ALARM,
  LIGHT_SWITCH,
  DOM_CAMERA,
  ALOCITY_READER,
  DEFAULT_IMAGE_CAMERA,
  BULLET_IMAGE_CAMERA,
  CORNER_IMAGE_CAMERA,
  MICRO_DOME_IMAGE_CAMERA,
  FISHEYE_IMAGE_CAMERA,
  DOME_IMAGE_CAMERA,
};

export default Images;
